<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style=" color: white; text-align: center; margin-bottom: 10px">
    Introduction to Pre-Primary Branch
  </h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: fit; border-radius: 10px"
      src="assets/img/school/pre-primary.jpg"
    />
  </div>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body text-justify">
            <p>
              Pre-primary class is the very beginning class of primary branch.
              The students who qualify academically from various sections are
              admitted to this class. <br />
              Through this class a student gets involved in the basic activities
              of academic education. Students who pass this class get admission
              in class one. <br />
              Activities of this class can be arranged as follows-
              <br />
              <strong>Academic Skills</strong>
              <br />
              <strong>Bengali and English</strong> <br />
              Students are able to read and write Bengali and English alphabets
              and form words and sentences with letters.
              <br />
              <strong>Mathematical Reasoning</strong> <br />
              Students gain skills in writing numbers (1-100), small to large
              number, large to small number, even numbers, matching numbers by
              drawing dots, odd numbers, memorizing time tables (1-5) and do
              addition and subtraction.
              <br />
              <strong>Religion and Moral Education</strong> <br />
              Along with academic education, students are imparted religious
              education and moral education following the syllabus provided by
              the government.
              <br />
              <strong>Drawing</strong> <br />
              Drawing is very crucial for children with special needs. They
              enjoy this kind of activities very much and it accelerates their
              intellectual development. A skilled drawing teacher works with
              each student in 1:1 session.
              <br />
              In addition, students acquire the ability to say and write names
              of seven days, names of twelve months, names of different flowers
              and fruits, identifying objects by looking at pictures, own name,
              school name, parents' names and friends' names.
              <br />
              <strong>Therapy</strong> <br />
              As an educational institution for students with special needs,
              Proyash-Chattogram provides various types of therapy services.
              Notably, <br />
              Physiotherapy <br />
              Occupational therapy <br />
              Speech and Language Therapy <br />
              Each student receives the necessary therapy services from the
              mentioned therapies. <br />

              <strong>Socialization and Behavior</strong> <br />
              A notable aspect of special education programs is to make students
              socially acceptable and teach them to control their hyper activity
              or behavior. It is supposed that, a special student will acquire
              this behavior and socialism throughout his educational life. To
              achieve this, class mainly focuses on the following topics-
              Getting ideas about friends. <br />
              Learning to exchange greetings with closed ones. <br />
              Coloring in the same picture jointly. <br />
              Learning to work as directed by the teacher. <br />
              Play with everyone together. <br />
              Making a habit of sitting for a certain time etc.
              <br />
              <strong>ADL</strong> <br />
              Through this skill, a student acquires skills about the tasks that
              need to be done in his daily life. Such as- <br />
              Learn how to pack own school bag. <br />
              Learn how to wear and take off school dress. <br />
              Learning to wash hands before and after eating and after
              performing toilet. <br />
              Learn to take tiffin without the help of others. <br />
              Learn how to keep books and stationaries in place. <br />

              <strong>Story Telling</strong> <br />
              Listening and responding is a very effective method for special
              children. In this case, the teacher or classmates will tell the
              story and the other students will respond. <br />

              <strong>Attending Skill</strong> <br />
              By acquiring this skill, a student is able to increase his
              attention skill. The following tasks are practiced to acquire this
              skill. <br />
              Matching puzzles. <br />
              Making calculations with Abacus. <br />
              Matching objects with numbers. <br />
              Reading thoroughly from books. <br />

              <strong>Co-Curricular Activities</strong> <br />
              Along with regular classroom-based education, students participate
              in various extracurricular activities. For example, students
              perform dances, recitations, songs, drawings etc. on national days
              held at different times. Students participate in various
              competitions and win various prizes. <br />

              <strong>IT and Computers</strong> <br />
              Acquiring skills in computer education is the demand of the time.
              To fulfill the demand of the time, a modern Sheikh Russell Digital
              Lab has been set up in the school. In this lab, according to the
              qualification of this students, the get two computer class in a
              week. 2 skilled IT teachers conduct training through 1:1 session.
              <br />

              <strong>Play Skill</strong> <br />
              Sports is a fundamental part of education for every student. The
              following points are followed to acquire sports skills for
              pre-primary students. <br />
              Exercising as directed <br />
              Hitting the ball at the goal post <br />
              Running in open fields <br />
              Throwing the ball in the basket <br />
              Playing football and cricket etc. <br />

              <strong>Individualized Education Plan (IEP)</strong> <br />
              Teaching is delivered through 1:1 sessions with each student in
              this class. <br />
              An Individualized Education Plan (IEP) is prepared for each
              student at the beginning of the year which contains a one-year
              improvement plan for the respective student. Class teachers
              prepare lessons according to the IEP.
              <br />

              <strong>At present</strong> <br />
              There are 29 students studying in pre-primary class. This class
              has 3 teachers, 1 teaching assistant and 2 volunteer assistants.
              The students of this class have been participating in various
              competitions such as drawing, music, dance at various occasions at
              different time and brought many successes, glory as well as
              achievements. <br />
              The authorities have undertaken various activities to make this
              class more modern and up-to-date.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
